import * as React from 'react'

import { Review as Presenter, IProps } from './presenter'

export const Review = (props: IProps): JSX.Element => {
  return <Presenter {...props} />
}

export default Review
